var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6666 4.26732L11.7333 3.33398L7.99992 7.06732L4.26659 3.33398L3.33325 4.26732L7.06659 8.00065L3.33325 11.734L4.26659 12.6673L7.99992 8.93398L11.7333 12.6673L12.6666 11.734L8.93325 8.00065L12.6666 4.26732Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3633_126882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6666 4.26732L11.7333 3.33398L7.99992 7.06732L4.26659 3.33398L3.33325 4.26732L7.06659 8.00065L3.33325 11.734L4.26659 12.6673L7.99992 8.93398L11.7333 12.6673L12.6666 11.734L8.93325 8.00065L12.6666 4.26732Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3633_126882)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16V16H8.67581H0V0Z",
    fill: "#A9A9A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCross);
export default __webpack_public_path__ + "static/media/grey-cross.92a67ab54ee954f8a5e9a430a3e6a4a3.svg";
export { ForwardRef as ReactComponent };